import { hasClerkUser } from '@/biz/tool';
import { useCreatorDeliveryTimelineStore } from '@/hooks/useCreatorDeliveryTimelineStore';
import type { CreatorDeliveryAction } from '@/interface/creatorDeliveryTimeline';
import { getCreatorTimelineContentNodes } from './creatorDeliveryTimeline';
import {
  CreatorOrderV2ContractError,
  isCreatorOrderV2ApiError
} from '@/apis/creatorOrderV2/errors';
import i18n from '@/i18n';

export const canInvokeCreatorDeliveryAction = (
  orderId: string,
  action: CreatorDeliveryAction
) => {
  const state = useCreatorDeliveryTimelineStore.getState();
  return (
    state.orderId === orderId &&
    !state.loading &&
    !state.error &&
    !state.writesDisabled &&
    hasClerkUser() &&
    getCreatorTimelineContentNodes(state.timeline).some(
      (node) => node.data.target && node.actions.includes(action)
    )
  );
};
export const assertCreatorDeliveryAction = (
  orderId: string,
  action: CreatorDeliveryAction
) => {
  if (!canInvokeCreatorDeliveryAction(orderId, action))
    throw new CreatorOrderV2ContractError(
      i18n.t('delivery_timeline.action_unavailable')
    );
};
export const handleCreatorDeliveryWriteError = (error: unknown) => {
  if (
    isCreatorOrderV2ApiError(error) &&
    ['DISABLE_WRITES', 'DENY_ACCESS', 'EXIT_DETAIL'].includes(
      error.recoveryAction
    )
  )
    useCreatorDeliveryTimelineStore.getState().disableWrites();
};
